import styled from "@emotion/styled";
import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import { CustomerRegisterCrudType } from "../../types/types";
import SelectBox, { menuItemType } from "../selectBox";
import { SelectChangeEvent } from "@mui/material";
import useGetUserGroup from "../../hooks/useGetUserGroup";
import theme from "../../theme";
import { isOnlyNumber, isValidPassword } from "../../utils/util";
import { useWindowSize } from "@reactuses/core";
import DaumPost from "../DaumPost";
import { Label } from "../common/Label";
import { TextInput } from "../common/TextInput";
import { useI18n } from "../../locales";
//import { SrLable } from "../common/SrLabel";

const { sm, md } = theme.screen;

const InputField: React.FC<{
  form: CustomerRegisterCrudType;
  setForm: Dispatch<SetStateAction<CustomerRegisterCrudType>>;
  pwError: string;
  setPwError: Dispatch<SetStateAction<string>>;
  checkPwSpace: boolean;
  setCheckPwSpace: any;
  errors: any;
  setErrors: any;
}> = (props) => {
  const {
    form,
    setForm,
    pwError,
    setPwError,
    checkPwSpace,
    setCheckPwSpace,
  } = props;
  const { width } = useWindowSize();
  const [popup, setPopup] = useState(false);
  const { t } = useI18n();

  const handleSelectBox = (event: SelectChangeEvent<string>) => {
    setForm((prevState) => ({
      ...prevState,
      group_id: event.target.value.toString(),
    }));
  };

  const { data: GroupOptions } = useGetUserGroup({});
  const userGroupType: menuItemType[] = [];
  if (GroupOptions) {
    for (let i = 0; i < GroupOptions.length; i++) {
      userGroupType.push({
        value: GroupOptions[i].group_id,
        title: GroupOptions[i].name,
      });
    }
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "pw" && !isValidPassword(value)) {
      setPwError(
        t.manageCustomer.passwordRequirements
      );
    } else {
      setPwError("");
    }
    if (name === "pw" && value.includes(" ")) {
      // console.log("공백 감지 !");
      setCheckPwSpace(true);
    } else {
      setCheckPwSpace(false);
    }
  };

  const handleComplete = () => {
    setPopup(!popup);
  };

  const isIdErr = form.id.length > 0 && !isOnlyNumber(form.id);

  // useEffect(() => {
  //   // 생년월일 - 입력값 확인 (숫자 6자리)
  //   if (!form.birth) {
  //     setErrors((prev: any) => ({ ...prev, birthError: false }));
  //   }
  //   if (form.birth) {
  //     if (!isOnlyNumber(form.birth) || String(form.birth).length < 6) {
  //       setErrors((prev: any) => ({ ...prev, birthError: true }));
  //     } else if (isOnlyNumber(form.birth)) {
  //       setErrors((prev: any) => ({ ...prev, birthError: false }));
  //     }
  //   }

  //   // 성별 - 입력값 확인 (숫자 1자리)
  //   if (!form.sex) {
  //     setErrors((prev: any) => ({ ...prev, genderError: false }));
  //   }
  //   if (form.sex) {
  //     if (!isOnlyNumber(form.sex)) {
  //       setErrors((prev: any) => ({ ...prev, genderError: true }));
  //     } else if (isOnlyNumber(form.sex)) {
  //       setErrors((prev: any) => ({ ...prev, genderError: false }));
  //     }
  //   }
  // }, [form]);

  return (
    <UserInfoWrapper>
      <UserInfo>
        <FirstRow>
          {/* 소유자명 & 소유자 연락처 */}
          <InputWrapper>
            <Label text={t.manageCustomer.ownerName} htmlFor="name" isRequired />
            <TextInput
              autoComplete="off"
              id="name"
              name="name"
              width={"200px"}
              onChange={handleChange}
              value={form.name}
              placeholder={t.manageCustomer.maxCharacters20}
              minLength={1}
              maxLength={20}
            />
          </InputWrapper>
          <InputWrapper style={{ position: "relative" }}>
            <Label text={t.manageCustomer.ownerContact} htmlFor="id" isRequired />
            <TextInput
              autoComplete="off"
              id="id"
              name="id"
              width={"200px"}
              onChange={handleChange}
              value={form.id}
              placeholder={t.manageCustomer.noDashNumbers}
              minLength={10}
              maxLength={11}
            />
            {isIdErr && (
              <PwError style={{ position: "absolute", bottom: "-23px" }}>
                {t.manageCustomer.numbersOnly}
              </PwError>
            )}
          </InputWrapper>
        </FirstRow>

        {/* 주민번호 & 성별 */}
        {/* <SecondRow>
          <InputWrapper style={{ position: "relative", flexGrow: "1" }}>
            <Label text="주민번호 앞자리" htmlFor="birth" isRequired />

            <ResidentNumWrapper>
              <TextInput
                maxLength={6}
                defaultValue={form.birth}
                id="birth"
                name="birth"
                width={"200px"}
                onChange={handleChange}
                placeholder="생년월일 입력"
              />
              {errors.birthError && (
                <PwError style={{ position: "absolute", bottom: "-23px" }}>
                  숫자만 6자리 입력해 주세요.
                </PwError>
              )}
              <span>{`-`}</span>
              <BackNumber>
                <SrLable
                  labelText={`주민번호 뒷자리 첫번째 숫자`}
                  id="sex"
                />
                <TextInput
                  maxLength={1}
                  defaultValue={form.sex}
                  id="sex"
                  name="sex"
                  width={"50px"}
                  onChange={handleChange}
                  placeholder="숫자"
                />
                {errors.genderError && (
                  <PwError
                    style={{
                      position: "absolute",
                      bottom: "-23px",
                      right: "0",
                    }}
                  >
                    숫자만 1자리 입력해 주세요.
                  </PwError>
                )}
                <span>******</span>
              </BackNumber>
            </ResidentNumWrapper>
          </InputWrapper>
        </SecondRow> */}

        <ThirdRow>
          {/* 주소 & 상세주소 */}
          <InputWrapper style={{ marginBottom: "26px" }}>
            <Label text={t.manageCustomer.address} htmlFor="address" isRequired>
              <PostFindBtn onClick={handleComplete}>
                {t.manageUser.postcodeSearch}
              </PostFindBtn>
            </Label>
            <TextInput
              minLength={1}
              autoComplete="off"
              placeholder={t.manageCustomer.addressPlaceholder}
              id="address"
              name="address"
              width={"100%"}
              onChange={handleChange}
              value={form.address}
              disabled
            />
          </InputWrapper>
          <InputWrapper style={{ marginBottom: "26px" }}>
            <Label text={t.manageCustomer.detailAddress} htmlFor="address_detail" />
            <TextInput
              autoComplete="off"
              placeholder={t.manageCustomer.maxCharacters100}
              id="address_detail"
              name="address_detail"
              width={"100%"}
              onChange={handleChange}
              value={form.address_detail}
              maxLength={100}
            />
          </InputWrapper>
          {popup && (
            <DaumPost
              open={popup}
              close={handleComplete}
              setForm={setForm}
              top={"420px"}
              left={"310px"}
              width={`${width}px`}
            />
          )}
        </ThirdRow>

        <FirstRow>
          {/* 기타 & 담당기관 */}
          <InputWrapper>
            <Label text={t.manageCustomer.other} htmlFor="illness" />

            <TextInput
              defaultValue={form.illness}
              id="illness"
              name="illness"
              width={"200px"}
              onChange={handleChange}
              placeholder={t.manageCustomer.otherPlaceholder}
            />
          </InputWrapper>
          <InputWrapper>
            {/* <Label text="담당기관" htmlFor="gov_id" /> */}
            <Label text={t.manageCustomer.groupLabel} htmlFor="gov_id" />

            <SelectBox
              filter={form.group_id}
              menuItems={userGroupType}
              width={width <= md ? "100%" : "200px"}
              handleChange={handleSelectBox}
              mr="0px"
              useSearch
              srLabel={t.manageCustomer.groupSrLabel}
            />
          </InputWrapper>
        </FirstRow>
        {/* 비밀번호 */}
        <InputWrapper style={{ position: "relative" }}>
          <Label text={t.manageCustomer.password} htmlFor="pw" isRequired />

          <TextInput
            style={{ marginBottom: "5px" }}
            placeholder={t.manageCustomer.passwordPlaceholder}
            id="pw"
            name="pw"
            type="password"
            autoComplete="new-password"
            minLength={8}
            width={"100%"}
            onChange={handleChange}
            value={form.pw}
          />
          {pwError && <PwError>{pwError}</PwError>}
          {checkPwSpace && (
            <PwError>{t.manageCustomer.passwordSpaceError}</PwError>
          )}
        </InputWrapper>
      </UserInfo>
    </UserInfoWrapper>
  );
};

const UserInfoWrapper = styled.div`
  background: ${theme.color.neutral_50};
  border-radius: 10px;
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 30px;
  padding-bottom: 30px;
  width: 100%;
  display: flex;
  gap: 44px;
  margin-bottom: 40px;

  @media (max-width: ${sm}px) {
    padding: 10px;
  }
`;

const UserInfo = styled.div`
  width: 100%;
`;

const FirstRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 26px;

  @media (max-width: ${md}px) {
    flex-direction: column;
    gap: 26px;
  }
`;

const ThirdRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${sm}px) {
    width: 100%;
  }
  @media (min-width: (${sm + 1}px)) and (max-width: ${md}px) {
    width: 100%;
  }
`;

const PostFindBtn = styled.button`
  margin-left: 10px;
  height: 25px;
  background: ${theme.color.neutral_200};
  border: 1px solid rgb(0, 0, 0, 0);
  border-radius: 5px;
  cursor: pointer;
  color: ${theme.color.neutral_500};
  &:hover {
    border: 1px solid ${theme.color.neutral_400};
  }

  @media (max-width: ${md}px) {
    height: 20px;
    font-size: ${theme.fontSize.FONT_2};
  }
`;

const PwError = styled.p`
  font-size: 10px;
  color: ${theme.color.red_500};
  padding: 5px;
  white-space: pre-line;
`;

/*const BackNumber = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  width: 190px;

  @media (max-width: ${md}px) {
    gap: 5px;
    width: 100%;

    span {
      font-size: 14px;
    }
  }
`;

const ResidentNumWrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${md}px) {
    gap: 5px;
  }
`;*/
export default InputField;
